import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DialogBox from "../DialogBox/DialogBox";

function Header({ onAboutClick, onServicesClick }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openDialog, setOpenDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  return (
    <AppBar
      position="sticky"
      sx={{
        width: "100%",
        height: { xs: "4rem", sm: "5rem" },
        backgroundColor: "black",
        justifyContent: "center",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
        }}
      >
        {/* Logo and Menu Icon (mobile layout) */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography
            variant="h5"
            sx={{ display: "flex", alignItems: "center", fontSize: "2.5rem" }}
          >
            <span style={{ color: "#C62828", marginRight: "0.5rem" }}>
              Third
            </span>
            <span style={{ color: "grey" }}>Axis</span>
          </Typography>

          {isMobile ? (
            <Box>
              <IconButton
                color="inherit"
                onClick={handleMenuOpen}
                edge="end"
                sx={{ color: "white" }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    onServicesClick();
                  }}
                >
                  Services
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    onAboutClick();
                  }}
                >
                  About
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>Get a Quote</MenuItem>
              </Menu>
            </Box>
          ) : (
            <Box sx={{ display: "flex", gap: 6, alignItems: "center" }}>
              <Box>
                <Button style={{ color: "white" }} onClick={onServicesClick}>
                  Services
                </Button>
                <Button style={{ color: "white" }} onClick={onAboutClick}>
                  About
                </Button>
              </Box>

              <Button
                variant="outlined"
                sx={{
                  color: "white",
                  borderColor: "white",
                  borderRadius: "50px",
                  px: 4,
                  py: 1,
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "#C62828",
                    backgroundColor: "rgba(255, 0, 0, 0.1)",
                  },
                }}
                onClick={() => setOpenDialog(true)}
              >
                Get a Quote
              </Button>
            </Box>
          )}
        </Box>
        <DialogBox open={openDialog} handleClose={() => setOpenDialog(false)} />
      </Toolbar>
    </AppBar>
  );
}

export default Header;
